// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"1674e029","551":"73e4141c"}[chunkId] + ".chunk.js";
};